module.exports = __webpack_public_path__ + "img/tool-box.3f8f710c.png";